export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-list-thumbnails-25e10a139968f91a36565e6c65c7f934.svg";